import React from "react";
import styles from "./Quote.module.scss";
import * as ReactDOMServer from "react-dom/server";

export default function Quote(props) {
  const { text, caption, image = null } = props;
  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <div className={styles.quote} />
        <p className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />
        {caption && (
          <div
            className={styles.author}
            dangerouslySetInnerHTML={{ __html: caption }}
          />
        )}
      </div>
      <div className={styles.row}>
        {image && (
          <div className={styles.image}>
            <img src={image} loading="lazy" alt="alt" />
          </div>
        )}
      </div>
    </div>
  );
}

export function renderQuoteComponent(props) {
  return ReactDOMServer.renderToString(<Quote {...props} />);
}
